export default "__VITE_ASSET__efEviCR4__"